
import { defineComponent, PropType } from 'vue'
import UIChipInput, { ChipOption } from '~/components/Common/UI2/ChipInput/UIChipInput.vue'

export default defineComponent({
  name: 'CodebaseContext',
  components: {
    UIChipInput
  },
  props: {
    testPatterns: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    excludePatterns: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    testPatternChips(): ChipOption[] {
      return this.testPatterns.map((pattern) => ({
        label: pattern,
        value: { id: pattern }
      }))
    },
    excludePatternChips(): ChipOption[] {
      return this.excludePatterns.map((pattern) => ({
        label: pattern,
        value: { id: pattern }
      }))
    }
  },
  methods: {
    updateTestPatterns(chips: ChipOption[]) {
      this.$emit(
        'updatePatterns',
        chips.map((c) => c.label)
      )
    },
    updateExcludePatterns(chips: ChipOption[]) {
      this.$emit(
        'updateExcludePatterns',
        chips.map((c) => c.label)
      )
    }
  }
})
